module.exports = {
    login: '/login',
    logout: '/logout',
    admin: '/admin',
    stocks: '/stocks',
    root: '/',
    priceChecker: '/pricechecker',
    picking: '/picking',
    incomingAiInvoices: '/incoming-ai-invoices',
    stocktake: '/stocktake',
    docConfirmation: '/doc-confirmation',
    labelPrinting: '/label-printing',
};
